import { isEmpty } from 'lodash-es';

export const getTrimSummary = (trims, trimValue) => {
  if (isEmpty(trims)) {
    return null;
  }
  return trims.find(trim => trim.trim === trimValue) || trims[0];
};
